<div class="tooltip text-es-blue-light" #tooltip>
  <ng-content select="[tooltip-label]"></ng-content>
  <div class="tooltiptext {{yStyle}} {{xStyle}}">
    <ng-content select="[tooltip-text]"></ng-content>
  </div>
</div>